// Trust Score threshold - only show scores >= 50 to avoid discouraging buyers
const TRUST_SCORE_THRESHOLD = 50;

export default function TrustScore({ score, size = 'md', forceShow = false }) {
  // Hide low trust scores unless explicitly forced to show
  if (score < TRUST_SCORE_THRESHOLD && !forceShow) {
    return null;
  }
  
  const dims = size === 'lg' ? 120 : size === 'md' ? 80 : 48;
  const stroke = size === 'lg' ? 8 : size === 'md' ? 6 : 4;
  const r = (dims - stroke) / 2;
  const circ = 2 * Math.PI * r;
  const offset = circ - (score / 100) * circ;
  const color = score >= 75 ? 'hsl(var(--accent-green))' : 'hsl(var(--accent-gold))';
  const label = score >= 75 ? 'Trusted' : 'Verified';
  const fontSize = size === 'lg' ? 'text-2xl' : size === 'md' ? 'text-base' : 'text-xs';
  const labelSize = size === 'sm' ? 'hidden' : 'text-[9px]';

  return (
    <div data-testid="trust-score" className="relative inline-flex items-center justify-center" style={{ width: dims, height: dims }}>
      <svg width={dims} height={dims} className="-rotate-90">
        <circle cx={dims / 2} cy={dims / 2} r={r} fill="none" stroke="hsl(var(--border))" strokeWidth={stroke} />
        <circle
          cx={dims / 2} cy={dims / 2} r={r} fill="none"
          stroke={color} strokeWidth={stroke} strokeLinecap="round"
          strokeDasharray={circ} strokeDashoffset={offset}
          style={{ transition: 'stroke-dashoffset 1s ease-out', animation: 'trust-ring 1.2s ease-out' }}
        />
      </svg>
      <div className="absolute inset-0 flex flex-col items-center justify-center">
        <span className={`${fontSize} font-bold font-mono-display`} style={{ color }}>{score}</span>
        <span className={`${labelSize} font-medium uppercase tracking-wider text-muted-foreground`}>{label}</span>
      </div>
    </div>
  );
}
